module.exports = __webpack_public_path__ + "static/media/connect-linear-middle-waifu.a6057211.svg";